/* Shop1913 BFCM 2026 early-access page.
   Loaded by the bfcm-hero section. Every behaviour hangs off data-bfcm-* attributes, so the
   sections stay independent and nothing here touches the rest of the theme. */
(function () {
  'use strict';

  var root = document.documentElement;
  var REG = 'bfcm-registered';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------- countdown */
  var target = null;
  function readTarget() {
    var hero = document.querySelector('[data-bfcm-hero]');
    var t = hero ? Date.parse(hero.getAttribute('data-target') || '') : NaN;
    target = isNaN(t) ? null : t;
  }
  function tick() {
    if (target === null) return;
    var s = Math.max(0, Math.floor((target - Date.now()) / 1000));
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600);
    document.querySelectorAll('[data-bfcm-count]').forEach(function (el) {
      var tpl = el.getAttribute('data-template') || '';
      el.textContent = tpl.replace('{days}', d).replace('{hours}', h);
    });
  }
  var timer = null;
  function startClock() {
    readTarget();
    tick();
    if (!timer) timer = setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------- helpers */
  function setEmail(el, value) {
    if (!el) return;
    var i = value.indexOf('@');
    el.textContent = i > 0 ? value.slice(0, i) : value;
    if (i > 0) { el.appendChild(document.createElement('wbr')); el.appendChild(document.createTextNode(value.slice(i))); }
  }
  function scrollToHero(focus) {
    var hero = document.getElementById('bfcm-top');
    if (!hero) return;
    hero.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (focus && !root.classList.contains(REG)) {
      setTimeout(function () {
        var email = hero.querySelector('[data-bfcm-form] input[type="email"]');
        if (email) email.focus({ preventScroll: true });
      }, 500);
    }
  }

  /* ---------------------------------------------------------- PushOwl form token
     PushOwl's embedded form sends a subscriber token saved in this browser (pushowl_embedded_subscriber_token,
     falling back to pushowl_subscriber_token). With a stale token the API answers "success" but only updates the
     old subscriber, so the sign-up never reaches the BFCM list. On this page only, drop those two tokens (and
     PushOwl's IndexedDB copies) on every load and again just before submit, so each sign-up is a new subscriber.
     Web push, popup and visitor tokens are left alone. */
  var PUSHOWL_FORM_KEYS = ['pushowl_embedded_subscriber_token', 'pushowl_subscriber_token'];
  function clearPushOwlFormToken() {
    try { PUSHOWL_FORM_KEYS.forEach(function (k) { localStorage.removeItem(k); }); } catch (e) {}
    try {
      var req = indexedDB.open('keyval-store');
      req.onsuccess = function () {
        var db = req.result;
        if (!db.objectStoreNames.contains('keyval')) { db.close(); return; }
        var tx = db.transaction('keyval', 'readwrite');
        PUSHOWL_FORM_KEYS.forEach(function (k) { tx.objectStore('keyval').delete(k); });
        tx.oncomplete = tx.onerror = function () { db.close(); };
      };
    } catch (e) {}
  }

  /* ---------------------------------------------------------- hero */
  function initHero(hero) {
    if (hero.__bfcm) return;
    hero.__bfcm = true;

    var form = hero.querySelector('[data-bfcm-form]');
    var holder = hero.querySelector('[data-bfcm-holder]');
    var stubEmail = hero.querySelector('[data-bfcm-stub-email]');
    var status = hero.querySelector('[data-bfcm-status]');
    var step1 = hero.querySelector('[data-bfcm-step1]');
    var alertsEls = hero.querySelectorAll('[data-bfcm-alerts]');
    var currentEmail = '';
    var currentAlerts = 'Email';
    var sawEmailField = false;
    var done = false;

    function emailInput() { return form && form.querySelector('input[type="email"]'); }
    function wantsText() {
      if (!form) return false;
      var boxes = form.querySelectorAll('input[type="checkbox"]');
      for (var i = 0; i < boxes.length; i++) if (boxes[i].checked) return true;
      return false;
    }
    function syncCard() {
      var input = emailInput();
      if (input) { sawEmailField = true; currentEmail = (input.value || '').trim(); }
      currentAlerts = wantsText() ? 'Email + SMS' : 'Email';
      if (holder) {
        setEmail(holder, currentEmail || holder.getAttribute('data-placeholder') || '');
        holder.classList.toggle('bfcm-empty', !currentEmail);
      }
      alertsEls.forEach(function (el) { el.textContent = currentAlerts; });
    }
    if (form) {
      form.addEventListener('input', syncCard);
      form.addEventListener('change', syncCard);
      /* Capture phase runs before PushOwl's own submit handler reads the token */
      form.addEventListener('submit', clearPushOwlFormToken, true);
      form.addEventListener('click', function (e) {
        if (e.target.closest('button[type="submit"], input[type="submit"]')) clearPushOwlFormToken();
      }, true);
    }
    clearPushOwlFormToken();
    syncCard();

    function fillPass(email) {
      setEmail(stubEmail, email || 'you@example.com');
      alertsEls.forEach(function (el) { el.textContent = currentAlerts; });
      if (step1) step1.textContent = currentAlerts === 'Email' ? step1.getAttribute('data-email-text') : step1.getAttribute('data-sms-text');
      if (status) status.textContent = status.getAttribute('data-on') || 'Active';
      var dot = status;
      if (dot) dot.classList.add('bfcm-on');
    }
    /* Success goes straight to the issued pass; CSS fades it in (no intermediate card state). */
    function issuePass(animate) {
      if (done) return;
      done = true;
      fillPass(currentEmail);
      root.classList.add(REG);
      tick();
      if (animate) hero.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
    function undoPass() {
      done = false;
      root.classList.remove(REG);
      if (status) { status.textContent = status.getAttribute('data-off') || ''; status.classList.remove('bfcm-on'); }
    }

    /* Success: the form shows its own success panel, moves on from its email step, or redirects back with ?registered=1 */
    function looksDone() {
      if (!form || done) return false;
      var ok = form.querySelector('#success-message');
      if (ok && (ok.classList.contains('sib-form-message-panel--active') || (ok.offsetParent !== null && ok.textContent.trim()))) return true;
      var generic = form.querySelectorAll('[class*="success"],[id*="success"]');
      for (var i = 0; i < generic.length; i++) {
        if (generic[i].offsetParent !== null && generic[i].textContent.trim()) return true;
      }
      if (sawEmailField && !emailInput() && currentEmail) return true;
      return false;
    }
    var queued = false;
    if (form && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          syncCard();
          if (looksDone()) issuePass(true);
        });
      }).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    }

    var param = hero.getAttribute('data-success-param') || 'registered';
    var qs = new URLSearchParams(window.location.search);
    if (qs.get(param)) { currentEmail = qs.get('email') || currentEmail; issuePass(false); }

    /* Theme editor preview */
    var designMode = window.Shopify && window.Shopify.designMode;
    if (designMode) {
      if (hero.hasAttribute('data-preview-registered')) { currentEmail = 'soror.j@gmail.com'; issuePass(false); }
      else if (!qs.get(param)) undoPass();
    }

    /* Share menu */
    var toggle = hero.querySelector('[data-bfcm-share-toggle]');
    var menu = hero.querySelector('[data-bfcm-share-menu]');
    if (toggle && menu) {
      var urlField = menu.querySelector('[data-bfcm-share-url]');
      var copyBtn = menu.querySelector('[data-bfcm-copy]');
      var nativeBtn = menu.querySelector('[data-bfcm-native]');
      var pageUrl = window.location.origin + window.location.pathname;
      var msg = hero.getAttribute('data-share-message') || '';
      var subject = hero.getAttribute('data-share-subject') || document.title;
      var enc = encodeURIComponent;
      var links = {
        whatsapp: 'https://wa.me/?text=' + enc(msg + ' ' + pageUrl),
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + enc(pageUrl),
        x: 'https://twitter.com/intent/tweet?text=' + enc(msg) + '&url=' + enc(pageUrl),
        threads: 'https://www.threads.net/intent/post?text=' + enc(msg + ' ' + pageUrl),
        pinterest: 'https://pinterest.com/pin/create/button/?url=' + enc(pageUrl) + '&description=' + enc(msg),
        linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + enc(pageUrl),
        sms: 'sms:?&body=' + enc(msg + ' ' + pageUrl),
        email: 'mailto:?subject=' + enc(subject) + '&body=' + enc(msg + '\n\n' + pageUrl)
      };
      menu.querySelectorAll('[data-net]').forEach(function (a) { a.href = links[a.getAttribute('data-net')]; });
      if (urlField) urlField.value = pageUrl;
      if (navigator.share && nativeBtn) nativeBtn.hidden = false;

      var openMenu = function (open) {
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open) { var first = menu.querySelector('[data-net]'); if (first) first.focus(); }
      };
      toggle.addEventListener('click', function () { openMenu(menu.hidden); });
      document.addEventListener('click', function (e) {
        if (!menu.hidden && !e.target.closest('.bfcm-share-wrap')) openMenu(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) { openMenu(false); toggle.focus(); }
      });
      if (copyBtn) copyBtn.addEventListener('click', function () {
        var finish = function () {
          copyBtn.textContent = 'Copied';
          setTimeout(function () { copyBtn.textContent = 'Copy link'; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(pageUrl).then(finish, finish);
        else { urlField.select(); document.execCommand('copy'); finish(); }
      });
      if (nativeBtn) nativeBtn.addEventListener('click', function () {
        navigator.share({ title: subject, text: msg, url: pageUrl }).catch(function () {});
      });
    }
  }

  /* ---------------------------------------------------------- calendar */
  function initCalendar(sec) {
    if (sec.__bfcm) return;
    sec.__bfcm = true;

    var cells = Array.prototype.slice.call(sec.querySelectorAll('.bfcm-cdrop'));
    var rows = Array.prototype.slice.call(sec.querySelectorAll('.bfcm-offer-row'));
    var cap = sec.querySelector('[data-bfcm-caption]');
    var dialog = sec.querySelector('[data-bfcm-dialog]');
    var svg = sec.querySelector('[data-bfcm-link]');
    var path = svg && svg.querySelector('path');
    var dots = svg ? svg.querySelectorAll('circle') : [];
    var touch = window.matchMedia('(max-width: 1000px)');
    var wrapEl = sec;
    var active = null, pinned = null, leaveT = null, raf = 0;

    var capIdle = function () { return touch.matches ? (cap.getAttribute('data-touch') || '') : (cap.getAttribute('data-desktop') || ''); };
    var rowFor = function (d) { return rows.filter(function (r) { return r.getAttribute('data-d') === String(d); })[0]; };
    var cellFor = function (d) { return cells.filter(function (c) { return c.getAttribute('data-d') === String(d); })[0]; };

    function drawLink() {
      if (active === null || !path) return;
      var row = rowFor(active), cell = cellFor(active);
      if (!row || !cell) return;
      var o = wrapEl.getBoundingClientRect();
      var rh = row.querySelector('.bfcm-row-h').getBoundingClientRect();
      var rr = row.getBoundingClientRect();
      var t = cell.getBoundingClientRect();
      var x1 = rr.right + 6 - o.left, y1 = rh.top + rh.height / 2 - o.top;
      var x2 = t.left - 6 - o.left, y2 = t.top + t.height / 2 - o.top;
      var k = Math.max(40, (x2 - x1) * 0.5);
      path.setAttribute('d', 'M' + x1 + ' ' + y1 + ' C' + (x1 + k) + ' ' + y1 + ' ' + (x2 - k) + ' ' + y2 + ' ' + x2 + ' ' + y2);
      if (dots[0]) { dots[0].setAttribute('cx', x1); dots[0].setAttribute('cy', y1); }
      if (dots[1]) { dots[1].setAttribute('cx', x2); dots[1].setAttribute('cy', y2); }
    }
    function loop() { drawLink(); raf = active === null ? 0 : requestAnimationFrame(loop); }

    function activate(d) {
      clearTimeout(leaveT);
      if (touch.matches || active === d) return;
      active = d;
      cells.concat(rows).forEach(function (x) {
        var on = x.getAttribute('data-d') === String(d);
        x.classList.toggle('bfcm-on', on);
        if (x.classList.contains('bfcm-offer-row')) x.setAttribute('aria-expanded', String(on));
      });
      sec.classList.add('bfcm-focus');
      var row = rowFor(d);
      if (cap && row) cap.textContent = row.getAttribute('data-caption') || '';
      if (!raf) raf = requestAnimationFrame(loop);
    }
    function clear() {
      active = null;
      cells.concat(rows).forEach(function (x) { x.classList.remove('bfcm-on'); });
      rows.forEach(function (r) { r.setAttribute('aria-expanded', 'false'); });
      sec.classList.remove('bfcm-focus');
      if (cap) cap.textContent = capIdle();
    }
    function leave() {
      clearTimeout(leaveT);
      leaveT = setTimeout(function () { if (pinned !== null) activate(pinned); else clear(); }, 140);
    }
    function pin(d) { pinned = pinned === d ? null : d; if (pinned === null) clear(); else activate(d); }

    function openSheet(d) {
      var row = rowFor(d);
      if (!dialog || !row) return;
      var q = function (n) { return dialog.querySelector('[data-bfcm-sheet="' + n + '"]'); };
      q('date').textContent = row.getAttribute('data-date') || '';
      q('title').textContent = row.getAttribute('data-name') || '';
      q('open').textContent = row.getAttribute('data-opens') || '';
      q('note').textContent = row.getAttribute('data-note') || '';
      var prods = row.querySelector('.bfcm-prods');
      q('prods').innerHTML = prods ? prods.innerHTML : '';
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    }
    function choose(d) { if (touch.matches) openSheet(d); else pin(d); }

    cells.forEach(function (c) {
      var d = c.getAttribute('data-d');
      c.addEventListener('mouseenter', function () { activate(d); });
      c.addEventListener('mouseleave', leave);
      c.addEventListener('focus', function () { activate(d); });
      c.addEventListener('blur', leave);
      c.addEventListener('click', function () { choose(d); });
    });
    rows.forEach(function (r) {
      var d = r.getAttribute('data-d');
      r.addEventListener('mouseenter', function () { activate(d); });
      r.addEventListener('mouseleave', leave);
      r.addEventListener('click', function (e) { if (e.target.closest('a')) return; choose(d); });
      r.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(d); }
      });
    });
    if (dialog) {
      var x = dialog.querySelector('[data-bfcm-sheet-close]');
      if (x) x.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
    if (touch.addEventListener) touch.addEventListener('change', function () { clear(); pinned = null; });
    if (cap) cap.textContent = capIdle();
  }

  /* ---------------------------------------------------------- boot */
  function initAll() {
    document.querySelectorAll('[data-bfcm-hero]').forEach(initHero);
    document.querySelectorAll('[data-bfcm-calendar]').forEach(initCalendar);
    startClock();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bfcm-jump]');
    if (!a) return;
    e.preventDefault();
    var dlg = document.querySelector('dialog[data-bfcm-dialog][open]');
    if (dlg) dlg.close();
    scrollToHero(true);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
